<template lang="">
  <div class="wrapper-ve" id="vexe" ref="content">
    <div class="header-ve">
      <div
        class="logo"
        style="width: 110px; margin-right: 10px"
        v-if="vexe.logo != ''"
      >
        <img :src="vexe.logo" alt="" />
      </div>
      <div class="header-left">
        <h2
          class="header-name"
          style="text-transform: uppercase; font-weight: 600"
        >
          {{ vexe.tencongty }}
        </h2>
        <p class="header-address">ĐC: {{ vexe.diachi }}</p>
        <p class="header-address">
          SĐT Phòng vé {{ vexe.diemden }}: {{ vexe.sdtpvden }}
        </p>
        <p class="header-address">
          SĐT Phòng vé {{ vexe.diemdi }}: {{ vexe.sdtpvdi }}
        </p>
        <p class="header-mst" style="font-weight: 600">
          MST:
          <span>
            {{ vexe.mst }}
          </span>
        </p>
      </div>
      <div class="header-right">
        <p class="header-mst">
          Ký hiệu (Serial):
          <span>
            {{ vexe.kyhieu }}
          </span>
        </p>

        <p class="header-mst" v-if="vexe.so != ''">
          Số (No.):
          <span class="text-bold">
            {{ vexe.so }}
          </span>
        </p>
      </div>
    </div>

    <div class="content">
      <h2 class="content-title">
        VÉ XE KHÁCH
        <span style="color: #ff0000">{{ vexe.tendoanhnghiep }}</span>
      </h2>
      <p class="content-desc">(Bản thể hiện của vé xe khách điện tử)</p>
    </div>
    <div class="main-ve">
      <div class="main-ve-left">
        <img
          style="width: 200px; height: 160px"
          width="200"
          height="160"
          src="data:image/png;base64,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"
        />

        <p class="qr-desc">Di chuyển camera đến mã QR để quét</p>
        <p class="qr-desc">Move camera to QR code to scan</p>
      </div>
      <div class="main-ve-center">
        <p style="margin-bottom: 10px">
          <span class="main-ticket-time">
            {{ $Helper.formatTime(vexe.ngaythang) }}, Ngày
            {{ $Helper.formatDate(vexe.ngaythang) }}
          </span>
        </p>
        <p class="main-ticket-data">
          {{ vexe.diemdi }}
        </p>

        <p class="main-ticket-data">
          <i
            class="fa fa-ellipsis-v"
            style="height: 32px; color: rgb(47, 134, 166); font-size: 36px"
          ></i>
        </p>

        <p class="main-ticket-data">
          {{ vexe.diemden }}
        </p>
      </div>
      <div class="main-ve-right">
        <p class="main-right-price">
          Giá: {{ Number(vexe.gia).toLocaleString().replaceAll(",", ".") }} VNĐ
        </p>
        <p class="main-right-price-desc">({{ vexe.chuthich }})</p>
        <p class="main-right-price-data">
          <span style="font-weight: 600">SĐT HK:</span>
          <span>
            {{ $Helper.formatPhone(vexe.sdthk) }}
          </span>
        </p>
        <p class="main-right-price-data">
          <span style="font-weight: 600">Biển số xe:</span>
          <span>
            {{ vexe.bienso }}
          </span>
        </p>
        <p class="main-ticket-time">
          Số ghế:
          <span>
            {{ vexe.soghe }}
          </span>
        </p>
      </div>
    </div>
    <p style="text-align: center; margin-top: 5px" class="main-ticket-time">
      MCCQT:
      {{ vexe.mccqt }}
    </p>
    <div class="footer">
      <div class="footer-line"></div>
      <div class="footer-content">
        <p class="footer-content-text">
          Giải pháp Hóa đơn điện tử được cung cấp bởi: Công ty Cổ phần Dịch vụ
          T-Van HiLo, MST: 0106713804, ĐT: 1900 29 29 62, Web: hilo.com.vn
        </p>
        <p class="footer-content-text">
          (Tra cứu hóa đơn điện tử tại: tracuuhddt78.hilo.com.vn, mã tra cứu: )
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    vexe: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    console.log(this.vexe.tencongty, this.$Helper);
  },
};
</script>
<style lang="css" scoped>
.wrapper-ve {
  width: 808px;
  padding: 18px;
  background: #fff;
  margin: 0 auto;
  /* margin-top: 100px; */
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.2);
  text-align: left;
  position: relative;
  top: 100px;
}

.container {
  width: 100%;
}

.header-ve {
  display: flex;
  justify-content: space-between;
}

.header-left {
  width: 62%;
  text-align: left;
}

.header-right {
  text-align: left;
}

.header-name {
  color: #2f86a6;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  padding: 0;
}

.header-address {
  color: #3d3d3d;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
}

.header-mst {
  line-height: 24px;
  font-size: 14px;
  margin: 10px 0;
}

.header-mst > span {
  color: #ff0000;
}

.header-mst > .text-bold {
  font-weight: 600;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content-title {
  font-size: 25px;
  text-transform: uppercase;
  font-weight: 600;
  color: #2f86a6;
}

.content-desc {
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  margin-top: 5px;
}

.main-ve {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  padding: 0 15px;
}

.qr-desc {
  color: #3d3d3d;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
}

.main-ticket-time {
  font-size: 18px;
  color: #2f86a6;
  font-weight: 600;
  margin-bottom: 6px;
}

.main-ticket-data {
  font-size: 22px;
  color: #2f86a6;
  font-weight: 600;
  margin-bottom: 6px;
}

.main-ve-right {
  text-align: left;
}

.main-ve-center {
  text-align: left;
}

.main-right-price {
  font-size: 28px;
  color: #2f86a6;
  font-weight: 800;
  margin-bottom: 6px;
}

.main-right-price-desc {
  font-size: 11px;
  font-style: italic;
  margin-top: 15px;
  margin-bottom: 10px;
}

.main-right-price-data {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
}

.main-right-price-data > span {
  margin-left: 5px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.footer-line {
  width: 95%;
  background: #3d3d3d;
  height: 2px;
  display: block;
  margin: 0 0 20px 0;
}

.footer-content-text {
  font-size: 11px;
  color: #3d3d3d;
  text-align: center;
}

.icon-elliipse {
  font-size: 40px;
}

@media print {
  body {
    line-height: 120%;
    background: #fff;
  }
}

@media screen {
  body {
    line-height: 1.4em;
    background: silver;
  }
}
</style>
